import { render, staticRenderFns } from "./SideBrand.vue?vue&type=template&id=150a1be9&"
import script from "./SideBrand.vue?vue&type=script&lang=js&"
export * from "./SideBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports